export default __webpack_public_path__ + "static/media/ibmplexserif-text-webfont.13628991.ttf";